/** Shared with News listing (`NewsCard`) and article-style cards (`ArticleCard`, e.g. More to digest). */
export const ARTICLE_CARD_LINK_CLASS = 'group block'

export const ARTICLE_CARD_MEDIA_WRAP_CLASS =
  'aspect-5/3 bg-[#D9D9D9] transition-all group-hover:bg-white/10 overflow-hidden relative'

export const ARTICLE_CARD_IMAGE_CLASS =
  'object-cover transition-transform duration-500 group-hover:scale-105'

export const ARTICLE_CARD_TITLE_CLASS =
  'mt-5.75 text-white text-[15px] font-medium leading-normal font-kode-mono group-hover:text-accent-gold transition-colors'
